module.exports = __webpack_public_path__ + "static/media/angry.47c8edff.svg";